@if (embeddedEnabled()) {
  <form class="elf" [formGroup]="loginForm" (ngSubmit)="submit()" novalidate>
    @if (errorMessage(); as message) {
      <p class="elf__error" role="alert"><i class="bx bx-error-circle" aria-hidden="true"></i>{{ message }}</p>
    }

    <div class="elf__field">
      <label class="elf__label" for="elf-email">Email</label>
      <input
        id="elf-email"
        class="elf__input"
        type="email"
        formControlName="emailAddress"
        placeholder="you@example.com"
        autocomplete="email"
        [attr.aria-invalid]="showError('emailAddress')"
        [attr.aria-describedby]="showError('emailAddress') ? 'elf-email-error' : null" />
      @if (showError('emailAddress')) {
        <p class="elf__field-error" id="elf-email-error" role="alert">
          <i class="bx bx-error-circle" aria-hidden="true"></i>Enter the email you signed up with.
        </p>
      }
    </div>

    <div class="elf__field">
      <div class="elf__label-row">
        <label class="elf__label" for="elf-password">Password</label>
        <button type="button" class="elf__forgot" (click)="onForgotPassword()">Forgot password?</button>
      </div>
      <input
        id="elf-password"
        class="elf__input"
        type="password"
        formControlName="password"
        autocomplete="current-password"
        [attr.aria-invalid]="showError('password')"
        [attr.aria-describedby]="showError('password') ? 'elf-password-error' : null" />
      @if (showError('password')) {
        <p class="elf__field-error" id="elf-password-error" role="alert">
          <i class="bx bx-error-circle" aria-hidden="true"></i>Enter your password.
        </p>
      }
    </div>

    <div class="elf__actions">
      <button type="submit" class="elf__submit abx-login__cta" [disabled]="pending()">
        {{ pending() ? 'Signing you in…' : 'Sign in' }}
      </button>
      @if (showCreateAccount()) {
        <p class="elf__signup">
          New to AppliedBioX?
          <button type="button" class="elf__signup-link" (click)="createAccount.emit()">Create an account</button>
        </p>
      }
    </div>
  </form>
} @else {
  <div class="elf">
    <div class="elf__actions elf__actions--redirect">
      <button type="button" class="elf__submit abx-login__cta" (click)="redirectLogin.emit()">
        {{ showCreateAccount() ? 'Log in / Sign up' : 'Log in' }}
      </button>
      @if (showCreateAccount()) {
        <p class="elf__signup">Creating an account takes under a minute.</p>
      }
    </div>
  </div>
}
